export const FETCH_USER_PERMISSION = 'publicador/blockedUser/FETCH_USER_PERMISSION';
